

export default function About1() {
	return (
		<>

			<div className="tf-widget-about-us main-content">
				<div className="themeflat-container">
					<div className="tf-about-us">
						<div className="row">
							<div className="col-md-6 image-wraper">
								<div className="media">
									<div className="media-v1 wow fadeInLeft animated">
										<img className="mask-media" src="images/proplay/Multisport 3.jpeg" alt="image" style={{ objectFit: 'cover' }} />
										<img className="shape-media" src="images/about/graphic.png" alt="image" />
									</div>
									<img src="images/proplay/badminton_ai.jpg" alt="image" className="image-gr wow fadeInRight animated" style={{ objectFit: 'cover' }} />
									<img src="images/about/Intersect.png" alt="image" className="intersect-img" />
								</div>
							</div>
							<div className="col-md-6">
								<div className="about-box">
									<img src="images/about/graphic-box.png" alt="image shape" />
									{/* header style v1 */}
									<div className="title-box title-small-v2">
										<span className="sub-title wow fadeInUp animated">Welcome to PROPLAY!</span>
										<h2 className="title-section wow fadeInUp animated" style={{ color: "#ffffff" }}>Elevating your Sporting Journey
										</h2>
									</div>{/* header style v1 */}
									<p className="post wow fadeInUp animated">
										PROPLAY - Your Ultimate Sports Community <br/>
Welcome to our vibrant Sports platform, where we provide the ultimate sports experience for your kids, hosts multisports events, fitness & other wellness programme.
									</p>
									<div className="line" />

								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
